export default __webpack_public_path__ + "static/media/referral-marketing.6b21f182.svg";